'use client';

import { motion } from 'framer-motion';
import { ArrowLeft, XCircle } from 'lucide-react';

interface PaymentFailedScreenProps {
  onRetry: () => void;
  onGoHome: () => void;
}

export function PaymentFailedScreen({
  onRetry,
  onGoHome,
}: PaymentFailedScreenProps) {
  return (
    <div className="flex min-h-screen items-center justify-center p-4">
      <motion.div
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        className="w-full max-w-sm rounded-3xl bg-card p-8 text-center shadow-xl"
      >
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ type: 'spring', delay: 0.2 }}
          className="mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-red-500/20"
        >
          <XCircle className="h-12 w-12 text-red-500" />
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
          className="mb-2 text-2xl font-bold"
        >
          Оплата не прошла
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4 }}
          className="mb-6 text-muted-foreground"
        >
          Платёж был отменён или произошла ошибка.
          Попробуйте ещё раз.
        </motion.p>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5 }}
          className="space-y-3"
        >
          <button
            onClick={onRetry}
            className="w-full rounded-xl bg-primary py-3 font-medium text-primary-foreground transition-colors hover:bg-primary/90"
          >
            Попробовать снова
          </button>

          <button
            onClick={onGoHome}
            className="flex w-full items-center justify-center gap-2 rounded-xl bg-secondary py-3 font-medium transition-colors hover:bg-secondary/80"
          >
            <ArrowLeft className="h-4 w-4" />
            На главную
          </button>
        </motion.div>
      </motion.div>
    </div>
  );
}
